// Screw family name with its Rothoblaas catalog photo (HTML #famPicker), in the family select and the solutions table.
import type { FC } from "react";
import cx from "classnames";
import { screwFamilyImage } from "./familyImages";
import styles from "./FamilyCell.module.css";

type FamilyCellProps = { family: string; inTable?: boolean };

const FamilyCell: FC<FamilyCellProps> = ({ family, inTable = false }) => {
  const src = screwFamilyImage(family);
  return (
    <span className={cx(styles.cell, inTable && styles.tableCell)}>
      <b>{family}</b>
      {src ? <img className={styles.img} src={src} alt="" draggable={false} /> : null}
    </span>
  );
};

export default FamilyCell;
